import React from 'react';

import DTRadialGauge from '../widgets/dt-special/DTRadialGauge';
import DTSimulationGauge from '../widgets/dt-special/DTSimulationGauge';
import DTTemperatureGrid from '../widgets/dt-special/DTTemperatureGrid';
import DTTemperatureTrend from '../widgets/dt-special/DTTemperatureTrend';
import DTMeteringBars from '../widgets/dt-special/DTMeteringBars';
import DTBreakerData from '../widgets/dt-special/DTBreakerData';
import DTVFDStatus from '../widgets/dt-special/DTVFDStatus';
import DTStatusIndicators from '../widgets/dt-special/DTStatusIndicators';
import DTVoltageTable from '../widgets/dt-special/DTVoltageTable';
import DTCurrentTable from '../widgets/dt-special/DTCurrentTable';
import DTGeneralInfo from '../widgets/dt-special/DTGeneralInfo';

import GeneralChartWidget from '../widgets/general/GeneralChartWidget';
import GeneralGaugeWidget from '../widgets/general/GeneralGaugeWidget';
import GeneralValueWidget from '../widgets/general/GeneralValueWidget';
import GeneralTableWidget from '../widgets/general/GeneralTableWidget';
import GeneralControlWidget from '../widgets/general/GeneralControlWidget';
import GeneralStatusCard from '../widgets/general/GeneralStatusCard';

import { CHART_TYPES, GAUGE_TYPES } from './dtWidgetTypes';

const REGISTRY = {
  'dt-radial-gauge':      DTRadialGauge,
  'dt-simulation-gauge':  DTSimulationGauge,
  'dt-temperature-grid':  DTTemperatureGrid,
  'dt-temperature-trend': DTTemperatureTrend,
  'dt-metering-bars':     DTMeteringBars,
  'dt-breaker-data':      DTBreakerData,
  'dt-vfd-status':        DTVFDStatus,
  'dt-status-indicators': DTStatusIndicators,
  'dt-voltage-table':     DTVoltageTable,
  'dt-current-table':     DTCurrentTable,
  'dt-general-info':      DTGeneralInfo,
};

export function resolveWidgetComponent(type) {
  if (REGISTRY[type]) return REGISTRY[type];
  if (CHART_TYPES.has(type)) return GeneralChartWidget;
  if (GAUGE_TYPES.has(type)) return GeneralGaugeWidget;
  if (type === 'Single Value' || type === 'Multi Value') return GeneralValueWidget;
  if (type === 'Status Card') return GeneralStatusCard;
  if (type === 'Timeseries Table') return GeneralTableWidget;
  if (['Status', 'Switch', 'Set Value'].includes(type)) return GeneralControlWidget;
  return null;
}

export function renderWidget(widget, data, theme, isEditMode, handlers) {
  const Component = resolveWidgetComponent(widget.type);
  if (!Component) {
    return (
      <div style={{ padding: 8, color: '#ff6b6b' }}>
        Unknown widget type: {widget.type}
      </div>
    );
  }
  return (
    <Component
      widget={widget}
      data={data}
      theme={theme}
      isEditMode={isEditMode}
      {...handlers}
    />
  );
}
